import dayjs from "dayjs";

type TimeSlotLike = {
  date?: string | null;
  hour_from?: string | null;
  hour_to?: string | null;
  start?: string | null;
  stop?: string | null;
};

const normalizeTimeValue = (time: string | null | undefined) => {
  if (!time) {
    return null;
  }

  const trimmedTime = time.trim();
  const directTimeMatch = trimmedTime.match(/^(\d{1,2}:\d{2})(?::(\d{2}))?$/);

  if (directTimeMatch) {
    const [, hourAndMinute, seconds = "00"] = directTimeMatch;

    return `${hourAndMinute}:${seconds}`;
  }

  const embeddedTimeMatch = trimmedTime.match(/[T ](\d{1,2}:\d{2})(?::(\d{2}))?/);

  if (!embeddedTimeMatch) {
    return null;
  }

  const [, hourAndMinute, seconds = "00"] = embeddedTimeMatch;

  return `${hourAndMinute}:${seconds}`;
};

const formatTimeSlotTime = (
  date: string | null | undefined,
  time: string | null | undefined,
  format: string,
) => {
  const normalizedTime = normalizeTimeValue(time);

  if (!date || !normalizedTime) {
    return "";
  }

  const parsedDateTime = dayjs(`${date}T${normalizedTime}`);

  if (!parsedDateTime.isValid()) {
    return "";
  }

  return parsedDateTime.format(format);
};

export const formatTimeSlotRange = (
  timeSlot: TimeSlotLike | null | undefined,
  format: string,
) => {
  const from = formatTimeSlotTime(
    timeSlot?.date,
    timeSlot?.hour_from ?? timeSlot?.start,
    format,
  );
  const to = formatTimeSlotTime(
    timeSlot?.date,
    timeSlot?.hour_to ?? timeSlot?.stop,
    format,
  );

  if (!from || !to) {
    return "";
  }

  return `${from} - ${to}`;
};
